import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IPayment } from '../models/payment';
import { IPaymentType } from '../models/payment-type';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  public applicationFeeType = "ApplicationFee";
  public readableApplicationFeeType = "Application Fee";
  public renewalFeeType = "RenewalFee"
  public readableRenewalFeeType = "Renewal Fee";
  public changeFeeType = "ChangeFee";

  public ihcLimitedPaymentOption = "IHC-Limited";
  public ihcBasicPaymentOption = "IHC-Basic";
  public ihcIntermediatePayemntOption = "IHC-Intermediate";
  public ihcComprehensivePaymentOption = "IHC-Comprehensive";
  public ihcSubunitPaymentOption = "IHC-Subunit";

  public hemoTechInitialProvisional = "hemoTechInitialProvisional";
  public hemoTechInitialFull = "hemoTechInitialFull";

  public paymentIssuedCommentSearchText = "Online Payment issued";
  public paymentAwaitingClearanceStatus = 'Awaiting Clearance';

  public paymentPendingStatus = 'Pending';
  public paymentApprovedAwaitingPayment = 'Approved, Pending Payment and Clearance'
  public paymentPaidStatus = 'Paid'
  public paymentClearedStatus = 'Cleared';

  public ihcInitialLimitedFeeSku = "IHC1";
  public ihcInitialBasicFeeSku = "IHC2";
  public ihcInitialIntermediateFeeSku = "IHC3";
  public ihcInitialComprehensiveFeeSku = "IHC4";
  public ihcInitialSubunitFeeSku = "IHC5";

  public ihcRenewalLimitedFeeSku = "IHC6";
  public ihcRenewalBasicFeeSku = "IHC7";
  public ihcRenewalIntermediateFeeSku = "IHC8";
  public ihcRenewalComprehensiveFeeSku = "IHC9";
  public ihcRenewalSubunitFeeSku = "IHC10";

  public ownershipChangeFeeSku = "IHC11";
  public limitedBasicSku = "IHC12";
  public limitedIntermediateSku = "IHC13";
  public limitedComprehensiveSku = "IHC14";
  public basicIntermediateSku = "IHC15";
  public basicComprehensiveSku = "IHC16";
  public intermediateComprehensiveSku = "IHC17";

  public ihcApplicationFeeNotice = `The In Home Care application will not be reviewed until payment has been received and cleared.
      After the In Home Care application has been submitted, a “Pay Fee” button will be displayed. By clicking this button,
      payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment
      if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted`;

  public paymentOptions: IPaymentType[] = [];
  /* public paymentOptions = [
    {
      text: 'In Home Care Limited',
      value: this.ihcLimitedPaymentOption,
      sku: this.ihcInitialLimitedFeeSku,
      fee: '2,000.00',
      notice: this.ihcApplicationFeeNotice
    },
    {
      text: 'In Home Care Basic',
      value: this.ihcBasicPaymentOption,
      sku: this.ihcInitialBasicFeeSku,
      fee: '2,250.00',
      notice: this.ihcApplicationFeeNotice
    },
    {
      text: 'In Home Care Intermediate',
      value: this.ihcIntermediatePayemntOption,
      sku: this.ihcInitialIntermediateFeeSku,
      fee: '2,500.00',
      notice: this.ihcApplicationFeeNotice
    },
    {
      text: 'In Home Care Comprehensive',
      value: this.ihcComprehensivePaymentOption,
      sku: this.ihcInitialComprehensiveFeeSku,
      fee: '3,000.00',
      notice: this.ihcApplicationFeeNotice
    },
    {
      text: 'In Home Care Subunit',
      value: this.ihcSubunitPaymentOption,
      sku: this.ihcInitialSubunitFeeSku,
      fee: '1,250.00',
      notice: this.ihcApplicationFeeNotice
    },
    {
      text: 'In Home Care Limited Renewal',
      value: this.ihcRenewalLimitedFeeSku,
      sku: this.ihcRenewalLimitedFeeSku,
      fee: '1,000.00',
      notice: ''
    },
    {
      text: 'In Home Care Basic Renewal',
      value: this.ihcRenewalBasicFeeSku,
      sku: this.ihcRenewalBasicFeeSku,
      fee: '1,000.00',
      notice: ''
    },
    {
      text: 'In Home Care Intermediate Renewal',
      value: this.ihcRenewalIntermediateFeeSku,
      sku: this.ihcRenewalIntermediateFeeSku,
      fee: '1,250.00',
      notice: ''
    },

    {
      text: 'In Home Care Comprehensive Renewal',
      value: this.ihcRenewalComprehensiveFeeSku,
      sku: this.ihcRenewalComprehensiveFeeSku,
      fee: '1,500.00',
      notice: ''
    },
    {
      text: 'In Home Care Subunit Renewal',
      value: this.ihcRenewalSubunitFeeSku,
      sku: this.ihcRenewalSubunitFeeSku,
      fee: '1,000.00',
      notice: ''
    },
    {
      text: 'Ownership Change Fee',
      value: this.ownershipChangeFeeSku,
      sku: this.ownershipChangeFeeSku,
      fee: '350.00',
      notice: ''
    },
    {
      text: 'Limited Basic',
      value: this.limitedBasicSku,
      sku: this.limitedBasicSku,
      fee: '250.00',
      notice: ''
    },
    {
      text: 'Limited Intermediate',
      value: this.limitedIntermediateSku,
      sku: this.limitedIntermediateSku,
      fee: '500.00',
      notice: ''
    },
    {
      text: 'Limited Comprehensive',
      value: this.limitedComprehensiveSku,
      sku: this.limitedComprehensiveSku,
      fee: '1,000.00',
      notice: ''
    },
    {
      text: 'Basic Intermediate',
      value: this.basicIntermediateSku,
      sku: this.basicIntermediateSku,
      fee: '250.00',
      notice: ''
    },
    {
      text: 'Basic Comprehensive',
      value: this.basicComprehensiveSku,
      sku: this.basicComprehensiveSku,
      fee: '750.00',
      notice: ''
    },
    {
      text: 'Intermediate Comprehensive',
      value: this.intermediateComprehensiveSku,
      sku: this.intermediateComprehensiveSku,
      fee: '500.00',
      notice: ''
    },
    {
      text: 'Hemo Tech Full Provisional',
      value: this.hemoTechInitialProvisional,
      applicationFee: '37.50',
      renewalFee: '37.50Cortana, what are you who are trying to want to play? ',
      applicationFeeNotice: `The HemoTech application will not be reviewed until payment has been received and cleared.
      After the HemoTech You have to tell and go, yeah, yeah, you have to tell and go. You cannot just go like that. application has been submitted, a “Pay Fee” button will be displayed. By clicking this button,
      payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment
      if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted`,
      renewalFeeNotice: ''
    },
    {
      text: 'Hemo Tech Full Initial',
      value: this.hemoTechInitialFull,
      applicationFee: '37.50',
      renewalFee: '150.00',
      applicationFeeNotice: `The HemoTech application will not be reviewed until payment has been received and cleared.
      After the HemoTech You have to tell and go, yeah, yeah, you have to tell and go. You cannot just go like that. application has been submitted, a “Pay Fee” button will be displayed. By clicking this button,
      payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment
      if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted`,
      renewalFeeNotice: ''
    }
  ] */

  public paymentTypes = [
    {
      value: this.applicationFeeType,
      text: 'Application Fee'
    },
    {
      value: this.renewalFeeType,
      text: 'Renewal Fee'
    },
    {
      value: this.changeFeeType,
      text: 'Change Fee'
    },
    {
      value: 'Other',
      text: 'Other'
    }
  ]

  public paymentStatuses = [this.paymentPendingStatus, this.paymentClearedStatus, this.paymentPaidStatus, this.paymentAwaitingClearanceStatus];
  public paymentMethods = [
    'Online',
    'Money Order',
    'Personal/Business Check',
    'Cashier\'s Check',
    'Cash'
  ];

  private api: string = environment.privateApi + 'Payments/';
  private http = inject(HttpClient);

  // constructor() {
  //   this.loadPaymentOptions();
  // }

  private loadPaymentOptions(): void {
    this.getAllPaymentTypes().subscribe({
      next: paymentTypes => this.paymentOptions = paymentTypes,
      error: error => {
        console.error('Error loading payment types:', error);
        this.paymentOptions = [];
      },
      complete: () => console.log('Finished loading payment types', this.paymentOptions)
    });
  }


  public getPaymentTypes(licenseType: string) : Observable<IPaymentType[]> {
    return this.http.get<IPaymentType[]>(this.api + 'GetPaymentTypes/' + licenseType);
  }

  public getAllPaymentTypes(): Observable<IPaymentType[]> {
    return this.http.get<IPaymentType[]>(this.api + 'GetPaymentTypes');
  }

  public updatePaymentType(request: IPaymentType): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'UpdatePaymentType', request);
  }

  public getPaymentTypeAmount(value: string): number {
    let option = this.paymentOptions.find(po => po.description == value);
    if (option != null && option != undefined) {
      return option.fee!;
    }
    return 0;
  }

  public getPaymentTypeDescription(value: string): string {
    if (!value)
      return '';
    const paymentType = this.paymentOptions.find(pt => pt.description === value);
    return paymentType ? paymentType.description : value;
  }

  getPaymentsByEntity(entityId: string, entityType: string): Observable<IPayment[]> {
    return this.http.get<IPayment[]>(this.api + 'GetPayments/' + entityType + '/' + entityId);
  }

  getPaymentsById(entityId: number): Observable<IPayment[]> {
    return this.http.get<IPayment[]>(this.api + 'GetPayments/' + entityId);
  }

  savePayment(payment: IPayment): Observable<IPayment> {
    return this.http.post<any>(this.api + "SavePayment", payment);
  }

  deletePayment(id: number, type: string): Observable<any> {
    return this.http.get<any>(this.api + 'DeletePayment/' + type + '/' + id);
  }

}
